/**
 * Simple Rect type. This is different
 * from PRRect since PRRect contains other functions like `.contains()`
 */
export type Rect = {
  x: number
  y: number
  width: number
  height: number
}

export interface ColorValues {
  red: number
  green: number
  blue: number
  // Alpha parameter (0-1)
  alpha?: number
}

export interface Color extends ColorValues {
  // ID of the colour variable, `colorVariableID` is always filled, in order to check if the color is a color variable we need to check `colorVariableName`
  colorVariableID?: string
  // ID of the colour variable in its source library
  colorVariableRemoteID?: string
  // Name of the colour variable
  colorVariableName?: string
  // Name of the library the colour variable comes from (only for foreign color variable)
  colorVariableSourceLibraryName?: string
  // ID of the source library
  colorVariableSourceLibraryID?: string
}

/**
 * Two dimensional point coordinates.
 */
export interface Point {
  x: number
  y: number
}

export interface ColorVariable extends Color {
  colorVariableName: string
}

/**
 * How a colour is rendered as text in the inspector, and copied to the
 * clipboard. This is a user preference, persisted per user.
 *
 * @todo Should come from the GraphQL schema once user preferences are
 * implemented there.
 */
export enum ColorFormat {
  HEX,
  RGB,
  HSL,
  OBJC_NSCOLOR,
  SWIFT_NSCOLOR,
  OBJC_UICOLOR,
  SWIFT_UICOLOR,
}

export interface Size {
  width: number
  height: number
}

/**
 * A named artboard size offered by the Mac app (e.g. "iPhone 15 Pro").
 */
export interface Preset {
  name: string
  width: number
  height: number
}
